<!-- 慈福新闻 -->
<template>
  <div class="pageView">
    <PCNavbar />
    <CarouselHome type="news" />
    <div class="main-wrap">
      <div class="block-wrap">
        <div class="tab">
          <div class="tab-item" :class="{ current: current == index + 1 }" v-for="(item, index) in fenlei" :key="index" @click="toggle(index + 1)">
            {{ item.name }}
          </div>
        </div>
        <div class="article" v-show="tagId == 127">
          <div class="list" v-if="newsList.length">
            <div class="list-box" v-for="(item, index) in newsList" :key="index" @click="handleToNewsDetails(item)">
              <el-image :src="item.image" class="img" />
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div>{{ item.jieshao }}</div>
                <div class="time">{{ item.show_time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="article" v-show="tagId == 143">
          <div class="list" v-if="newsList.length">
            <div class="list-box" v-for="(item, index) in newsList" :key="index" @click="handleToNewsDetails(item)">
              <el-image :src="item.image" class="img" />
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div>{{ item.jieshao }}</div>
                <div class="time">{{ item.show_time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div :class="{ article: platform == 'mobile' }" v-show="tagId == 268">
          <div class="video-list">
            <div class="video-item" v-for="(item, index) in newsList" :key="index" @click="playVideo(item)">
              <div class="video-box">
                <video class="video" :src="item.url" :poster="item.image"></video>
                <div class="video-mask">
                  <i class="el-icon-video-play" @click="playVideo(item)"></i>
                </div>
              </div>
              <div class="video-title">{{ item.title }}</div>
              <div class="video-desc">{{ item.jieshao }}</div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <el-pagination ref="pagination" layout="slot" :total="total" :current-page="page" hide-on-single-page>
            <div style="display: flex;justify-content: center;">
              <el-button type="text" class="custom-btn" :disabled="page <= 1" @click="handlePrevChange">
                <i class="el-icon-arrow-left"></i>
                上一页
              </el-button>
              <el-pagination
                layout="pager"
                :current-page="page"
                :pager-count="11"
                @current-change="handleCurrentChange"
                :page-size="10"
                :total="total">
              </el-pagination>
              <el-button type="text" class="custom-btn" :disabled="page >= lastPage" @click="handleNextChange">
                下一页
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="视频预览" :width="platform == 'web' ? '900px' : '100%'" center append-to-body>
      <video class="playvideo" :src="detail.video" controls="true" style="width: 100%"></video>
    </el-dialog>
    <Footer />
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import Footer from "@/components/footer/index";

export default {
  name: "News",
  components: { PCNavbar, CarouselHome, Footer },
  data() {
    return {
      current: 1,
      fenlei: [],
      newsList: [],
      page: 1,
      total: 0,
      lastPage: 1,
      tagId: '',
      dialogVisible: false,
      detail: {}
    };
  },
  watch: {
    $route(to) {
      const index = to.params.id || 1;
      this.toggle(index);
    },
  },
  computed: {
    ...mapState(["platform"]),
  },
  async created() {
    await this.getFenlei();
    this.$watch(
      "$route",
      (to) => {
        const index = to.params.id || 1;
        this.toggle(index);
      },
      { immediate: true }
    );
  },
  methods: {
    toggle(index) {
      this.current = index;
      this.page = 1;
      this.newsList = []
      this.getList();
      this.$store.dispatch("setMenuActive", "/news/" + index);
      // 更新路由参数
      this.$router.push({
        path: `/news/${index}`,
      });
    },

    async getFenlei() {
      const res = await CifuAPI.getArticleType({ model_type: "news" });
      if (res.code == 1) {
        this.fenlei = res.data;
      }
    },
    async getList() {
      const cid = this.fenlei[this.current - 1].id;
      this.tagId = this.fenlei[this.current - 1].id
      const res = await CifuAPI.getArticleList({
        page: this.page,
        model_type: "news",
        cid,
      });
      if (res.code == 1) {
        this.newsList = res.data.data;
        this.lastPage = res.data.last_page;
        this.total = res.data.total;
      }
    },
    handleToNewsDetails(item) {
      if (item.gzh_url) {
        window.open(item.gzh_url, 'blank')
      } else if (item.outlink) {
        window.open(item.outlink, 'blank')
      } else {
        this.$router.push(`/newsDetail?type=0&id=${item.id}`);
      }
    },
    handlePrevChange() {
      this.page--;
      this.getList()
    },
    handleCurrentChange(e) {
      this.page = e
      this.getList()
    },
    handleNextChange() {
      this.page++;
      this.getList()
    },
    playVideo(item) {
      if (item.outlink) {
        window.open(item.outlink, 'blank')
      } else {
        this.detail = item;
        this.dialogVisible = true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.pageView{
  width: 100%;
  min-width: 1400px;
}
.article {
  padding-top: 30px;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    padding-top: 20px;
  }
  .playvideo {
    width: 100%;
  }
}

.video {
  &-list {
    flex-wrap: wrap;
    gap: 30px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      gap: 10px;
    }
  }
  &-item {
    width: calc((100% - 90px) / 4);
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      width: 100%; // 移动端全宽显示
      margin-bottom: 20px;
    }
  }
  &-box {
    @media screen and (max-width: 1600px) and (min-width: 1200px) {
      height: 190px;
    }
    
    // 处理浏览器放大后的情况
    @media screen and (min-width: 1201px) {
      min-width: auto; // 1200px以上恢复完全响应式
    }
    
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      height: 200px; // 移动端固定高度
    }
  }
  
  &-title {
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      font-size: 16px !important;
      line-height: 20px !important;
      margin: 10px 0 5px 0 !important;
    }
  }
  
  &-desc {
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      font-size: 14px !important;
      line-height: 18px !important;
      margin-bottom: 10px !important;
    }
  }
}

.info{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .time{
    padding-bottom: 10px;
  }
}

// 移动端专门的样式优化
@media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  .pageView {
    .main-wrap {
      padding: 0 15px; // 移动端左右内边距
    }
    
    .block-wrap {
      width: 100%; // 移动端全宽
      max-width: 100%; // 确保不超出容器
    }
    
    .tab {
      flex-direction: column; // 移动端垂直排列
      gap: 10px; // 标签之间的间距
      
      .tab-item {
        width: 100% !important; // 移动端全宽
        height: 50px !important; // 移动端合适的高度
        font-size: 16px !important; // 移动端合适的字体
        border-bottom: 2px solid #e0e0e0; // 移动端边框
      }
    }
    
    .list {
      flex-direction: column; // 移动端垂直排列
      
      .list-box {
        flex-direction: column; // 移动端垂直排列
        align-items: center; // 居中对齐
        text-align: center; // 文字居中
        
        .img {
          width: 100% !important; // 移动端全宽
          height: 200px !important; // 移动端合适的高度
          margin-bottom: 15px; // 图片下方间距
        }
        
        .info {
          width: 100%; // 信息区域全宽
          padding-left: 0 !important; // 移除左内边距
          
          .title {
            font-size: 16px !important; // 移动端合适的标题字体
            line-height: 22px !important; // 移动端合适的行高
            margin-bottom: 10px; // 标题下方间距
          }
          
          .time {
            font-size: 14px !important; // 移动端合适的时间字体
            color: #828282;
          }
        }
      }
    }
    
    .pagination {
      margin-top: 30px; // 移动端分页上方间距
      
      .custom-btn {
        font-size: 14px !important; // 移动端合适的按钮字体
        padding: 8px 16px !important; // 移动端合适的按钮内边距
      }
    }
  }
}
::v-deep .img{
  width: 308px;
  height: 174px;
}
::v-deep .list-box{
  margin-bottom: 30px;
}
::v-deep .el-pager{
  li{
    background: #f5f5f5 !important;
    font-size: 18px;
    color: #999;
  }
  .active{
    color: #663301;
  }
}
</style>
